module.exports = __webpack_public_path__ + "static/media/lc.46775d93.svg";